// extracted by mini-css-extract-plugin
export default {"ParagraphSection":"ParagraphSection_ParagraphSection__ST0qa"};